import * as types from 'constants/ActionTypes';
import { Map } from 'immutable';

const defaultState = Map({
  isAuthenticated: false,
  isLoading: false,
  isBootstrapped: false,
  error: null,
  accountStatus: null,
  enrollmentStep: null,
  enrollmentIdentity: null,
  activationResult: null,
  programToken: null,
  usesReserhubAccount: false,
});

/**
 * Reducer for CDS Pasajero Frecuente loyalty account state.
 * @param {import('immutable').Map} state
 * @param {object} action
 * @returns {import('immutable').Map}
 */
export default function cdsFrequentPassenger(state = defaultState, action) {
  switch (action.type) {
    case types.SET_CDS_FP_LOADING:
      return action.isLoading
        ? state.set('isLoading', true)
        : state.set('isLoading', false).set('isBootstrapped', true);
    case types.SET_CDS_FP_ERROR:
      return state.set('error', action.error).set('isLoading', false).set('isBootstrapped', true);
    case types.CLEAR_CDS_FP_ERROR:
      return state.set('error', null);
    case types.SET_CDS_FP_ACCOUNT_STATUS:
      return state
        .set('accountStatus', action.accountStatus)
        .set('isAuthenticated', Boolean(action.isAuthenticated))
        .set('isLoading', false)
        .set('isBootstrapped', true)
        .set('error', null);
    case types.SET_CDS_FP_PROGRAM_TOKEN:
      return state.set('programToken', action.programToken);
    case types.SET_CDS_FP_ENROLLMENT_STEP:
      return state.set('enrollmentStep', action.step);
    case types.SET_CDS_FP_ENROLLMENT_IDENTITY:
      return state.set('enrollmentIdentity', action.enrollmentIdentity);
    case types.SET_CDS_FP_ACTIVATION_RESULT:
      return state.set('activationResult', action.activationResult);
    case types.CLEAR_CDS_FP_SESSION:
      return defaultState
        .set('isBootstrapped', true)
        .set('usesReserhubAccount', Boolean(action.usesReserhubAccount));
    default:
      return state;
  }
}
